import { BaseContainerModel } from '../../base-container.model';
import {
  bl_fi_mst_pricing_scheme_event_RowClass
} from '../../../dbschema';
import { ExtQueryCriteria } from '../../ExtQueryCriteria';

export class PricingSchemeEventContainerModel extends BaseContainerModel {
  bl_fi_mst_pricing_scheme_event: bl_fi_mst_pricing_scheme_event_RowClass =
    new bl_fi_mst_pricing_scheme_event_RowClass();
}

export class PricingSchemeEventQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  txn_type: string;
  txn_class: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  exts: ExtQueryCriteria[] = [];
}

